<template>
	<div class="chapter-wrapper">
		<transition name="zoom"> <!-- appear -->
			<keep-alive>
				<kleptos v-if="showSystem" class="theme-os" theme="theme-os"></kleptos>
			</keep-alive>
		</transition>

		<!-- ENTER SYSTEM -->
		<div class="kleptos-computer" @click="enterSystem"></div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex';
    import KleptOS from '@/components/KleptOS/KleptOS';

    export default {
        components: {
            kleptos: KleptOS,
        },
        computed: {
            ...mapGetters('gameOS', [
                'showSystem',
                // 'getTheme'
            ])
        },
        created(){
        	// this.$store.dispatch('gameOS/setTheme', 0);
        },
        methods: {
        	enterSystem() {
        		if (!this.showSystem) {
        			this.$store.dispatch('gameOS/showSystem', true);
        		}
        	},
        }
    }
</script>

<style lang="scss" scoped>

	.zoom-enter-active {
		transition: transform 600ms ease, opacity 600ms ease;
	}

	.zoom-leave-active {
		transition: transform 250ms ease, opacity 250ms ease;
	}

	.zoom-enter {
		transform: scale(0.8);
		opacity: 0;
	}

	.zoom-leave-to {
		transform: scale(0.9);
		opacity: 0;
	}

	.chapter-wrapper {
		display: flex;
		flex-direction: column;
		height: 100%;
		background: red;
		background: url(~@/assets/img/background-pc.jpg) no-repeat center center;
		background-size: cover;
	}

	.kleptos-computer {
		position: absolute;
		top: calc(50% - 222px/1.7);
		left: calc(50% - 305px/1.6);
		width: 305px;
		height: 222px;
		background: white;
		opacity: 0;
		transition: opacity 300ms ease;

		&:hover {
			opacity: 0.05;
		}
	}

	button {
		position: absolute;
		top: 0;
		width: 100%;
	}
</style>